import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
} from '@angular/core';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { routes } from './app.routes';
import localeFr from '@angular/common/locales/fr';
import {
  commonsProviders,
  commonsProvidersFrom,
} from './config/commons.config';
import { initProvider } from './config/init.config';

registerLocaleData(localeFr, 'fr');

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideRouter(routes),
    provideAnimations(),
    initProvider,
    importProvidersFrom(...commonsProvidersFrom),
    commonsProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
};
